import { UserService, UserSvcUserSetting } from '@kp/rest-api-javascript-sdk';

/**
 * Available languages
 */
export enum Language {
  en = 'en',
  de = 'de',
  nl = 'nl',
}

export type UserSettings = UserSvcUserSetting;

/**
 * Get user settings
 */
export const getUserSettings = () => UserService.getUsersMeSettings();
